/**
 * Import Lib & assets
 */

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

/**
 * styled components
 */

const Container = styled.div`
  ${t.mixins.flex()}
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.7;
  `}
`;
const Title = styled.p`
  ${t.mixins.rem(24, 30)};
  font-family: ${t.font.primary};
  font-weight: ${t.font.bold};
  text-transform: uppercase;
  color: ${t.color.white};
  text-align: right;
`;
const Arrow = styled.img.attrs({ src: t.image.arrow })`
  height: 29px;
  width: 29px;
  margin-left: 15px;
`;

/**
 * next component is..
 */

const Button__next = ({ title, onClick, disabled }) => (
  <Container onClick={onClick} disabled={disabled}>
    <Title>{title}</Title>
    <Arrow />
  </Container>
);

export default Button__next;

Button__next.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Button__next.defaultProps = {
  style: {},
};

/*
    import Button__next from 'components/button/next/button__next'
    <Button__next />
  */
